import styled from 'styled-components';

import variables from '../../../../styles/variables';
import Image from '../../../UI/Image/Image';
import { KioskProps } from '../../../../types';

export const InventoryBorder = styled.div`
  position: relative;
  display: flex;
  @media screen and (max-width: 397px) {
    &.reservationBlade {
      width: 140%;
    }
  }
`;

export const InventoryMessage = styled.div<KioskProps>`
  background-color: transparent;
  text-align: center;
  border-radius: 13px;
  display: flex;
  font-size: 12px;
  padding: 1px 0px 1px 16px;
  margin-left: 5px;

  @media screen and (max-width: 767px) {
    text-align: left;
  }
  
  @media screen and (max-width: 356px) {
    font-size: ${({ isKiosk }) => isKiosk ? variables.defaultMinFontSizeKiosk : 9}px;
  }

  &.pointer{
    cursor:pointer;
  }
  
  &.reservationBlade {
    padding: 3px 13px 3px 16px;
    font-size: 10px;
    @media screen and (max-width: 357px) {
      font-size: ${({ isKiosk }) => isKiosk ? variables.defaultMinFontSizeKiosk : 9}px;
      }
  }
`;

export const Icon = styled(Image)`
  position: absolute;
  left: 0;
  right: auto;
  width: 18px;
  top: 0;
  bottom: 0;
  margin: auto auto;
  @media screen and (max-width: 356px) {
    width: 16px;
    }
  }
  &.reservationBlade {
    width: 16px;
  }
`;

export const StoreCtaLink = styled.button`
  background: none;
  text-decoration: underline;
  border: none;
  padding: 0 0 0 4px;
  cursor: pointer;
  font-size: 12px;
  line-height: 14px;
  @media screen and (max-width: 767px) {
    text-align: right;
  }
`;
